module.exports = __webpack_public_path__ + "static/img/jdd-qpd.9bb5278c.png";